// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FullScreenImage__popup-fc81ac {
  background: url("/static/images/img-background.svg") repeat;
  display: flex;
}

.FullScreenImage__container-f9641b {
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.FullScreenImage__img-a5b35d {
  margin: auto;
  height: 100%;
  max-width: 100%;
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./src/main/Popups/ContextPopups/FullScreenImage/styles.m.css"],"names":[],"mappings":"AAAA;EACE,2DAAA;EACA,aAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,OAAA;AACF","sourcesContent":[".popup {\n  background: url('/static/images/img-background.svg') repeat;\n  display: flex;\n}\n\n.container {\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.img {\n  margin: auto;\n  height: 100%;\n  max-width: 100%;\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `FullScreenImage__popup-fc81ac`,
	"container": `FullScreenImage__container-f9641b`,
	"img": `FullScreenImage__img-a5b35d`
};
module.exports = ___CSS_LOADER_EXPORT___;
